import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { DatePicker, Modal, Table, Form, Input, Calendar, Row, Col, Popover, Popconfirm, Alert, Typography, Spin, Upload } from "antd";
import { openNotificationWithIcon } from "../../Function";
import moment from "moment";
import { PlusCircleOutlined, CalendarOutlined, DownloadOutlined, ClockCircleFilled, CloseOutlined } from "@ant-design/icons";
import { LichLeTetApi, TaoLichLeTetApi, DeleteLichLeTetApi } from "../../../api/getKhaiBao";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import { DownloadTempHolidayApi, UploadTempHolidayApi } from "../../../api/getInfoData";

const { Link } = Typography;

function disabledDate(current) {
    // Can not select days before today and today
    const currentDate = new Date();
    // console.log(currentDate.getMonth()-1)

    return current && current < moment(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1), 0).add(-1, 'days').endOf('day');
}

const ModalAddOvertime = ({ visible, onCancel, fetchData, currentDate }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, []);

    const onFinish = (values) => {

        TaoLichLeTetApi({
            ten: values.tenNgayLe,
            ngay: moment(values.dateLe).format("YYYY-MM-DD"),
            mota: values.moTa || ""
        })
            .then(res => {
                if (res.data.error) {
                    openNotificationWithIcon('error', res.data.error)
                } else {
                    fetchData({ nam: moment(currentDate).year() });
                    onCancel();
                    form.resetFields();
                };

            })
            .catch(err => {
                if (err.data.error) {
                    openNotificationWithIcon('error', err.data.error)
                };
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const fileDownload_TempHoliday = () => {
        const fnFileDownload = require('js-file-download')
        const filename = "Mau_DanhSachNgayLe.xlsx"
        DownloadTempHolidayApi({ nam: moment(currentDate).year() })
            .then(res => {
                fnFileDownload(res.data, filename);
            })
    }

    return (
        <Modal
            title={
                <Row>
                    <Col span={17}>
                        Thêm ngày lễ
                    </Col>
                    <Col span={6}>
                        <Button
                            type="link"
                            onClick={fileDownload_TempHoliday}
                            icon={<DownloadOutlined />}
                            size='middle'
                        >
                            File mẫu
                        </Button>
                    </Col>
                </Row>
            }
            visible={visible}
            onCancel={onCancel}
            footer={false}
        >
            <Form
                form={form}
                name="basic"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 18 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Ngày lễ"
                    name="tenNgayLe"
                    rules={[{ required: true, message: 'Vui lòng nhập ngày lễ.' }]}
                >
                    <Input maxLength={100} />
                </Form.Item>

                <Form.Item
                    label="Chọn ngày"
                    name="dateLe"
                    rules={[{ required: true, message: 'Vui lòng chọn ngày lễ.' }]}
                >
                    <DatePicker format={'DD/MM/YYYY'} style={{ width: "100%" }} disabledDate={disabledDate}
                    />
                </Form.Item>

                <Form.Item
                    label="Ghi chú"
                    name="moTa"
                >
                    <Input maxLength={100} />
                </Form.Item>

                <Alert
                    type="warning"
                    message="Lưu ý: Không thể tạo lịch cho các tháng kế trước."
                />
                <br />

                <Form.Item wrapperCol={{ offset: 10, span: 12 }}>
                    <Button type="success" htmlType="submit">
                        Thêm
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

const ModalViewCalendar = ({ visible, onCancel, fetchData, data, getButtonChangeStatus }) => {
    const [selectMonth, setSelectMonth] = useState(moment(new Date()));

    const content = (item) => (
        <>
            <Row>
                <Col span={10}>
                    Ghi chú:
                </Col>
                <Col span={14}>
                    {item.mota}
                </Col>
            </Row>
            <Row>
                <Col span={10}>
                    Người tạo:
                </Col>
                <Col span={14}>
                    {item.usernameTao}
                </Col>
            </Row>
            <Row>
                <Col span={10}>
                    Ngày tạo:
                </Col>
                <Col span={14}>
                    {moment(item.created).format("L HH:mm")}
                </Col>
            </Row>
            <Row>
                <Col span={10}>
                    Thao tác:
                </Col>
                <Col span={14}>
                    {getButtonChangeStatus(item)}
                </Col>
            </Row>
        </>
    );

    const dateCellRender = (value) => {
        return (
            data.map((item) =>
                value.format("YYYY-MM-DD") == item.ngay &&
                <Popover
                    key={item.id}
                    content={content(item)}
                    title=""
                    trigger="hover"
                    overlayInnerStyle={{ width: "200px" }}
                    overlayClassName="stylePop"
                >
                    <div key={item.id}>
                        <span style={{ borderBottom: "1px solid #90ca56" }}>
                            {item.ten}
                        </span>
                    </div>
                </Popover>
            )
        )
    }

    const onPanelChange = (date) => {
        setSelectMonth(moment(new Date(date._d)));
    }

    function monthCellRender(value) {
        return (
            <span className="text-capitalize">{value.format("MMMM")}</span>
        );
    }

    const onSelectMonth = (value) => {
        setSelectMonth(moment(new Date(value._d)));
        fetchData({ nam: moment(value._d).year() });
    }

    return (
        <Modal
            title={"Lịch lễ/tết tháng " + selectMonth.format('MM/YYYY')}
            visible={visible}
            onCancel={onCancel}
            footer={false}
            width={1000}
            bodyStyle={{ padding: "12px 6px 6px 6px" }}
        >
            <Row>
                <Col span={4}>
                    <Calendar
                        defaultValue={moment(new Date())}
                        onPanelChange={onPanelChange}
                        monthFullCellRender={monthCellRender}
                        mode={'year'}
                        className={'styleMonthCel'}
                        onSelect={onSelectMonth}
                    />
                </Col>
                <Col span={20}>
                    <Calendar
                        dateCellRender={dateCellRender}
                        onPanelChange={onPanelChange}
                        defaultValue={moment(new Date())}
                        value={selectMonth}
                        className="styleCalendar_1"
                    />
                </Col>
            </Row>
        </Modal>
    )
}

export const DanhSachNgayLe = () => {
    const defaultPageSize = 10;
    const [pager, setPager] = useState({ pageSize: defaultPageSize });
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [isShowAdd, setIsShowAdd] = useState(false);
    const [isShowView, setIsShowView] = useState(false);
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [fileExcelDataHoliday, setFileExcelDataHoliday] = useState([]);
    const [loading_page, setLoading_page] = useState(false);

    const fetchData = (params = {}) => {
        LichLeTetApi({ nam: params.nam })
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchData({ nam: moment(currentSelectedDate).year() });
    }, []);

    const onDelete = (record) => {
        DeleteLichLeTetApi({ id: record.id })
            .then(r => {
                fetchData({ nam: moment(currentSelectedDate).year() });
            })
            .catch(err => {
                if (err.data.error) {
                    openNotificationWithIcon('error', err.data.error)
                };
            });
    };

    const getButtonChangeStatus = (record) => {
        return (
            <div className={'row col-12'}>
                <Popconfirm
                    title="Xác nhận xóa"
                    onConfirm={() => onDelete(record)}
                    okText="Xóa"
                // onCancel={handleCancel}
                >
                    <span
                        title="Xóa ngày lễ"
                        className={'col'}
                        style={{ color: 'red', cursor: "pointer" }}
                    // onClick={()=>onDelete(record)}
                    >
                        <DeleteOutlined />
                    </span>
                </Popconfirm>

            </div>
        )
    };

    const columns = [
        {
            title: "STT",
            dataIndex: "index",
            key: "index",
            align: 'center',
            render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
            sortDirections: ['descend', 'ascend', 'descend'],
            ellipsis: true,
            width: 60
        },
        {
            title: "Ngày lễ",
            dataIndex: "ten",
            key: "ten",
            filterKey: 'ten',
            align: 'center',
            type: 'text',
            canSearch: true,
            render: name => name
        },
        {
            title: "Ghi chú",
            dataIndex: "mota",
            key: "mota",
            filterKey: 'mota',
            align: 'center',
            type: 'text',
            canSearch: true,
        },
        {
            title: "Ngày",
            dataIndex: "ngay",
            key: "ngay",
            filterKey: 'ngay',
            width: 150,
            align: 'center',
            type: 'text',
            canSearch: true,
            render: (value, record) => moment(value).format("DD/MM/YYYY"),
            sortDirections: ['descend', 'ascend', 'descend'],
            sorter: (a, b) => moment(a.ngay).unix() - moment(b.ngay).unix()
        },
        {
            title: "Người tạo",
            dataIndex: "usernameTao",
            key: "usernameTao",
            filterKey: 'usernameTao',
            width: 160,
            align: 'center',
            type: 'text',
            canSearch: true,
        },
        {
            title: "Ngày tạo",
            dataIndex: "created",
            key: "created",
            filterKey: 'created',
            width: 160,
            align: 'center',
            type: 'text',
            canSearch: true,
            render: (value, record) => moment(value).format("L HH:mm"),
        },
        {
            title: 'Thao tác',
            dataIndex: '',
            key: '',
            filterKey: '',
            width: 100,
            align: 'center',
            type: 'text',
            canSearch: true,
            render: ((text, record) => getButtonChangeStatus(record))
        },
    ]

    const handleChange = (pagination) => {
        const currentPager = { ...pager };
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({ ...currentPager });
        fetchData({
            status: currentPager.status,
            page_size: pagination.pageSize,
            page: pagination.current, search,
            nam: moment(currentSelectedDate).year()
        })
    }

    const onQuickChangeYear = (type) => {
        let yearChange;
        if (type === 'previous') {
            yearChange = moment(currentSelectedDate).subtract(1, 'year');
        } else {
            yearChange = moment(currentSelectedDate).add(1, 'year');
        }
        setCurrentSelectedDate(yearChange);
        fetchData({ nam: yearChange.year() });
    }

    const onChangeYear = (date) => {
        // setIsCreate(false)
        setCurrentSelectedDate(date);
        fetchData({ nam: moment(date).year() });
        // const lsDateTemp = getDateRange(date);
        // setLsDate(lsDateTemp);
    };

    const handleChangeUpload = ({ fileList }) => {
        setLoading_page(true);
        setFileExcelDataHoliday(fileList);
        if (fileList.length != 0) {
            var FormData = require('form-data');
            var data = new FormData();
            data.append('nam', moment(currentSelectedDate).year())
            if (fileList != undefined) {
                fileList.forEach(element => {
                    data.append('fileupload', element.originFileObj)
                })
            }
            UploadTempHolidayApi(data)
                .then(res => {
                    if (res.data.message != 'success') {
                        openNotificationWithIcon('error', "Lỗi", res.data.message)
                    } else {
                        openNotificationWithIcon('success', "Thành công", "Thêm dữ liệu thành công, vui lòng kiểm tra lại danh sách ngày lễ.");
                    }
                    setFileExcelDataHoliday([]);
                    fetchData({ nam: moment(currentSelectedDate).year() });

                    setLoading_page(false);
                })
                .catch(err => {
                    setFileExcelDataHoliday([]);
                    openNotificationWithIcon('error', "Không nhập được file yêu cầu. Bạn vui lòng thử lại.");
                    setLoading_page(false);

                });
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Danh sách ngày lễ/tết</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Nhân sự</Link></li>
                                <li className="breadcrumb-item"><Link href="#">Khai báo</Link></li>
                                <li className="breadcrumb-item active">Danh sách ngày lễ/tết</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                    <div className={'col'}>
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={() => onQuickChangeYear('previous')} title="Năm trước">
                            <i className={'fa fa-arrow-left'}></i>
                        </Button>
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={() => onQuickChangeYear('next')} title="Năm sau">
                            <i className={'fa fa-arrow-right'}></i>
                        </Button>
                        <DatePicker
                            style={{ borderRadius: 10 }}
                            className={'m-2'}
                            onChange={onChangeYear}
                            value={currentSelectedDate}
                            format={'YYYY'}
                            allowClear={false}
                            picker="year"
                        />
                        <Button ghost type='success' className={'m-2'} onClick={() => setIsShowAdd(true)} icon={<PlusCircleOutlined />} >Thêm ngày lễ</Button>
                        {/*<Button ghost type='dark' className={'m-2'} onClick={()=>setIsShowView(true)} icon={<CalendarOutlined />} >Xem dạng lịch</Button>*/}
                        {/* <Button
                            type={'danger'}
                            className={'m-2 btnGreen'}
                            style={{marginRight: 5}}
                            onClick={fileDownload_TempHoliday}>
                            Tải xuống file mẫu
                        </Button> */}
                        <Upload
                            accept=".xlsx"
                            onChange={handleChangeUpload}
                            fileList={fileExcelDataHoliday}
                            maxCount={1}
                            className={"styleUploadExcel"}
                            beforeUpload={file => {
                                return false;
                                // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                                //     messageBox('error','Lỗi', `Sai định dạng file. Chỉ chấp nhận: EXCEL (.xlsx).`)
                                //     return Upload.LIST_IGNORE;
                                // }
                                // return file.type === 'image/png' ? true : Upload.LIST_IGNORE;
                            }
                            }
                        >
                            <Button danger type="dashed" htmlType='button'>Tải lên danh sách</Button>
                        </Upload>
                    </div>

                </div>
            </div>
            <Spin spinning={loading_page}>
                <div className="row">
                    <Table
                        dataSource={data}
                        columns={columns}
                        loading={loading}
                        bordered={true}
                        // scroll={
                        //     { x: "30svh" }
                        // }
                        className={'custom-table-hover'}
                        // className
                        rowClassName={"styleTableLeTet"}
                        // size={'small'}
                        rowKey="id"
                        onChange={handleChange}
                        pagination={{
                            current: pager.current,
                            pageSize: pager.pageSize,
                            total: data.count,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            pageSizeOptions: ['10', '15', '25', '50']
                        }}
                    />
                </div>
            </Spin>
            <ModalAddOvertime
                visible={isShowAdd}
                onCancel={() => setIsShowAdd(false)}
                fetchData={fetchData}
                currentDate={currentSelectedDate}
            />
            <ModalViewCalendar
                visible={isShowView}
                onCancel={() => setIsShowView(false)}
                fetchData={fetchData}
                data={data}
                getButtonChangeStatus={getButtonChangeStatus}
            />
        </>
    )
}